module.exports = __webpack_public_path__ + "static/60e265c9bc8852197ad66e6abe612fcbd2f58efd86dde94f3be80406b98bed3e-aa5832b0902067a45706c827dd0e939b.png";